export const USER_TOKEN_TYPES = ['author', 'assignee', 'approved-by', 'reviewer'];

export const DROPDOWN_TYPE = {
  hint: 'hint',
  operator: 'operator',
};

export const FILTER_TYPE = {
  none: 'none',
  any: 'any',
};

export const MAX_HISTORY_SIZE = 5;

export const FILTERED_SEARCH = {
  MERGE_REQUESTS: 'merge_requests',
  ISSUES: 'issues',
  ADMIN_RUNNERS: 'admin/runners',
  GROUP_RUNNERS_ANCHOR: 'runners-settings',
};
